import { CHAT_FOLDER_LIST_QUERY_KEY } from "@frontend-shared/constants";
import type { ICreateChatFolderPayload } from "@frontend-shared/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { chatFolderApi } from "@/api/services";

export const useCreateChatFolder = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: ICreateChatFolderPayload) =>
      chatFolderApi.createChatFolder(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [CHAT_FOLDER_LIST_QUERY_KEY],
      });
    },
  });
};
